import script from "./header.vue?vue&type=script&setup=true&lang=js"
export * from "./header.vue?vue&type=script&setup=true&lang=js"

import "./header.vue?vue&type=style&index=0&id=81837c94&scoped=true&lang=less"

import exportComponent from "E:\\A-OnlineServiceCenter\\多语言多品牌售后\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81837c94"]])

export default __exports__